module.exports = __webpack_public_path__ + "static/media/tomoyanagishita63.e554490e.png";